/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUpdateSupplier
 */
export interface ControlcenterMelcoModelsUpdateSupplier {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpdateSupplier
     */
    name?: string | null;
}

export function ControlcenterMelcoModelsUpdateSupplierFromJSON(json: any): ControlcenterMelcoModelsUpdateSupplier {
    return ControlcenterMelcoModelsUpdateSupplierFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUpdateSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUpdateSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ControlcenterMelcoModelsUpdateSupplierToJSON(value?: ControlcenterMelcoModelsUpdateSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


